import script from "./FileHistoryTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileHistoryTable.vue?vue&type=script&setup=true&lang=ts"

import "./FileHistoryTable.vue?vue&type=style&index=0&id=79d49fb8&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d49fb8"]])

export default __exports__